'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../containers');

var _mobilesFilters = require('../../redux/modules/mobilesFilters');
var _propertySearch = require('../../redux/modules/propertySearch');

var _routerAdapter = require('../../helpers/routerAdapter');
var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _checkFiltersQuantity = require('./../../helpers/checkFiltersQuantity');var _checkFiltersQuantity2 = _interopRequireDefault(_checkFiltersQuantity);
var _constants = require('../../constants');

var _MobileFilterContainer = require('./MobileFilterContainer.scss');var styles = _interopRequireWildcard(_MobileFilterContainer);
var _PropertiesFilterContainer = require('../PropertiesFilterContainer/PropertiesFilterContainer.scss');var propFilterStyles = _interopRequireWildcard(_PropertiesFilterContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var FORM_ID = 'mobile-filters-form';var initialFieldsValues = { location: '', rooms: ['all'],
  propertyTypes: ['all'],
  status: ['all'],
  minPrice: '',
  maxPrice: '' };var


MobileFilterContainer = function (_Component) {_inherits(MobileFilterContainer, _Component);function MobileFilterContainer() {var _temp, _this, _ret;_classCallCheck(this, MobileFilterContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      selectedLocation: null,
      advancedFilters: {} }, _this.

























































    getAdvancedFiltersValues = function (values) {
      var filtersQuantity = (0, _checkFiltersQuantity2.default)(Object.assign({}, _this.state, { advancedFilters: values }), _this.props.routeData);
      _this.setState({ advancedFilters: values, filtersQuantity: filtersQuantity });
    }, _this.

    handleChange = function (field, value) {var _Object$assign, _this$setState;
      var filtersQuantity = (0, _checkFiltersQuantity2.default)(Object.assign({}, _this.state, (_Object$assign = {}, _Object$assign[field] = value, _Object$assign)), _this.props.routeData);
      _this.setState((_this$setState = {}, _this$setState[field] = value, _this$setState.filtersQuantity = filtersQuantity, _this$setState));
    }, _this.

    compareLocationsAndSaveToStore = function () {
      var routeLocation = _this.props.routeData.locationSearch ?
      _this.props.routeData.locationSearch.location :
      null;var
      location = _this.props.mobilesFilters.alreadySearchedLocation.location;

      if ((0, _isEqual2.default)(location, routeLocation)) {
        _this.setState({
          location: _this.props.mobilesFilters.alreadySearchedLocation[_this.props.routeData.locale].formatted });

      }
    }, _this.

    geocodeAddress = function (address) {var _this$props$routeData =
      _this.props.routeData,locale = _this$props$routeData.locale,locationSearch = _this$props$routeData.locationSearch;
      var cityName = (0, _get2.default)(locationSearch, 'en.city_name', '');
      var neighborhoodName = (0, _get2.default)(locationSearch, 'en.neighborhood', '');
      var streetName = (0, _get2.default)(locationSearch, 'en.street_name', '');

      var tags = [];
      if (cityName) {
        tags.push(cityName);
        if (streetName) {
          tags.push(streetName);
        } else if (neighborhoodName) {
          tags.push(neighborhoodName);
        }
      }
      var cleanedTags = tags.
      filter(function (part) {return !!part;}).
      map(function (keyPart) {return (0, _slugify2.default)(keyPart);});
      // Called only once, so is not necessary save an instance of Google Service
      new _googleService2.default(locale, function (googleService) {return googleService.geocodeLocusViaInternalBase(address, cleanedTags) // eslint-disable-line no-new
        .then(function (response) {
          _this.props.saveSearchedLocation(response);
          _this.setState({ location: response[locale].formatted });
        });});

    }, _this.

    resetForm = function () {
      _this.setState(Object.assign({},
      initialFieldsValues, {
        advancedFilters: Object.assign({}, _constants.advancedFiltersInitialValues, {

          commodities: [] }),

        filtersQuantity: 0 }));

    }, _temp), _possibleConstructorReturn(_this, _ret);}MobileFilterContainer.prototype.componentWillMount = function componentWillMount() {if (__CLIENT__) {this.bodyScrollPosition = document.body.scrollTop;document.querySelector('#content').style.display = 'none';setTimeout(function () {document.body.scrollTop = 0;});}var _props$routeData = this.props.routeData,optionType = _props$routeData.optionType,_props$routeData$para = _props$routeData.params,rooms = _props$routeData$para.rooms,types = _props$routeData$para.types,status = _props$routeData$para.status,price = _props$routeData$para.price,bathrooms = _props$routeData$para.bathrooms,toilets = _props$routeData$para.toilets,area = _props$routeData$para.area,constructionYear = _props$routeData$para.constructionYear,locationSearch = _props$routeData.locationSearch,locale = _props$routeData.locale;if ((0, _get2.default)(locationSearch, 'en.formatted')) {this.props.saveSearchedLocation(locationSearch);}this.resetButtonId = 'reset-mobile-filters-button';var filters = { rooms: rooms || initialFieldsValues.rooms, propertyTypes: types || initialFieldsValues.propertyTypes, status: status || initialFieldsValues.status, optionType: optionType || this.props.mobilesFilters.optionType, minPrice: price.minPrice || '', maxPrice: price.maxPrice || '', price: price.minPrice || price.maxPrice, location: (0, _get2.default)(locationSearch, '[' + locale + '].formatted') || (0, _get2.default)(locationSearch, 'en.formatted'), toilets: toilets || ['all'], bathrooms: bathrooms || ['all'], area: area || {}, constructionYear: constructionYear || {} };var filtersQuantity = (0, _checkFiltersQuantity2.default)(filters, this.props.routeData);this.setState(Object.assign({}, filters, { filtersQuantity: filtersQuantity }));};MobileFilterContainer.prototype.componentDidMount = function componentDidMount() {var _props$routeData2 = this.props.routeData,locationSearch = _props$routeData2.locationSearch,locale = _props$routeData2.locale;var alreadySearchedLocation = this.props.mobilesFilters.alreadySearchedLocation;if ((0, _get2.default)(locationSearch, 'en.formatted') && locale !== 'en') {if ((0, _get2.default)(alreadySearchedLocation, 'location')) {this.compareLocationsAndSaveToStore();} else {this.geocodeAddress(locationSearch.en.formatted);}}};MobileFilterContainer.prototype.componentWillUnmount = function componentWillUnmount() {var _this2 = this;if (__CLIENT__) {document.querySelector('#content').style.display = '';setTimeout(function () {document.body.scrollTop = _this2.bodyScrollPosition;});}};MobileFilterContainer.prototype.

  render = function render() {var _this3 = this;var _props =
    this.props,mobilesFilters = _props.mobilesFilters,routeData = _props.routeData;
    var isProjectsFilters = mobilesFilters.isProjects || routeData.location === 'projects';

    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }

    return (
      _react2.default.createElement('div', { className: '' + styles.mobileFilterContainer + (this.props.isRtl ? ' rtl' : '') },
        _react2.default.createElement('div', {
            id: this.resetButtonId,
            className: styles.resetButton },

          this.props.translate('search_box', 'clear')),

        _react2.default.createElement('div', { className: styles.filtersLabel },
          this.props.translate('search_box', 'filter'), '\xA0',
          !!this.state.filtersQuantity && '(' + this.state.filtersQuantity + ')'),

        _react2.default.createElement(_containers.MobilePropertiesFilters, {
          propertyTypes: this.props.propertyTypes,
          formId: FORM_ID,
          translate: this.props.translate('search_box'),
          rootTranslate: this.props.translate,
          fields: this.state,
          routeData: this.props.routeData,
          hideMobileFilters: this.props.hideMobileFilters,
          resetForm: this.resetForm,
          startSubmitting: this.props.startSubmitting,
          saveSearchedLocation: this.props.saveSearchedLocation,
          advancedFilters: this.state.advancedFilters,
          alreadySearchedLocation: this.props.mobilesFilters.alreadySearchedLocation,
          isAdvancedFiltersOpen: this.props.mobilesFilters.isAdvancedFiltersOpen,
          openAdvancedFilters: this.props.openAdvancedFilters,
          handleChange: this.handleChange,
          getAdvancedFiltersValues: this.getAdvancedFiltersValues,
          isRtl: this.props.isRtl,
          isMobile: this.props.isMobile,
          resetButtonId: this.resetButtonId,
          saveFiltersQuantity: function saveFiltersQuantity() {return _this3.props.changeActiveFiltersQuantity(_this3.state.filtersQuantity);},
          filtersType: isProjectsFilters ? 'projects' : 'homes' }),


        _react2.default.createElement('div', { className: styles.btnLinePrimary },
          _react2.default.createElement('button', {
              type: 'submit',
              className: 'btn btn-primary',
              form: FORM_ID },

            !this.props ?
            _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse ' + propFilterStyles.spinner }) :
            _react2.default.createElement('span', null, this.props.translate('search_box', 'searchContainer', 'search')))),





        _react2.default.createElement('div', { style: { height: '80px' } })));


  };return MobileFilterContainer;}(_react.Component);


MobileFilterContainer.propTypes = {
  routeData: _propTypes2.default.object.isRequired,
  translate: _propTypes2.default.func,
  hideMobileFilters: _propTypes2.default.func,
  startSubmitting: _propTypes2.default.func,
  saveSearchedLocation: _propTypes2.default.func,
  advancedFilters: _propTypes2.default.object,
  openAdvancedFilters: _propTypes2.default.func,
  mobilesFilters: _propTypes2.default.object,
  propertyTypes: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  changeActiveFiltersQuantity: _propTypes2.default.func.isRequired };


var mapStateToProps = function mapStateToProps(_ref) {var lang = _ref.lang,routing = _ref.routing,mobilesFilters = _ref.mobilesFilters,propertyTypes = _ref.propertyTypes;
  var routeData = (0, _routerAdapter.extractRouteData)(routing, lang.locale);

  return {
    locale: routeData.locale,
    routeData: routeData,
    mobilesFilters: mobilesFilters,
    translate: (0, _reduxPagan.getLang)(lang, 'static'),
    propertyTypes: propertyTypes.sorted };

};

var mapDispatchToProps = {
  hideMobileFilters: _mobilesFilters.hideMobileFilters,
  saveSearchedLocation: _mobilesFilters.saveSearchedLocation,
  openAdvancedFilters: _mobilesFilters.openAdvancedFilters,
  startSubmitting: _mobilesFilters.startSubmitting,
  changeActiveFiltersQuantity: _propertySearch.changeActiveFiltersQuantity };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
MobileFilterContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MobileFilterContainer/MobileFilterContainer.js
// module id = 2960
// module chunks = 0